module.exports = __webpack_public_path__ + "d53dc8c6ebe0012d7e7c2fc2c7eea56d.png";